<template>
  <div id="card-activity" class="activity">
    <AppSeparator class="card-window__separator" />
    <div class="activity__heading">
      <h3 class="activity__title">
        <AppIcon icon="far fa-comment-alt-lines" />
        {{ $t('card_modal.sections.activity') }}
        <AppCounterRounded v-if="userAlerts.length" :count="userAlerts.length" />
      </h3>
      <!-- detailed activity toggler -->
      <AppActionButton v-if="hasOtherActivities.length" @click="toggleDetailedActivity">
        {{ actionButtonText }}
      </AppActionButton>
    </div>
    <div class="activity__wrapper">
      <!-- comment box -->
      <CommentBox v-if="isCardActive" @save-comment="addComment" />
      <!-- looping activities -->
      <div class="activity__listing">
        <CardModalActivityItem
          v-for="activity in selectedActivities"
          :key="activity.id"
          :activity="activity"
          :class="isActivityActive(activity.id) && 'unread'"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { checkApiResponse } from 'Utils'
import CardActivityControl from '../mixins/CardActivityControl'
// Components
import AppIcon from 'Ui/AppIcon'
import AppSeparator from 'Ui/AppSeparator'
import CommentBox from 'Components/CommentBox'
import AppActionButton from 'Ui/AppActionButton'
import AppCounterRounded from 'Ui/AppCounterRounded'
import CardModalActivityItem from './CardModalActivityItem'

export default {
  name: 'CardModalActivity',

  components: {
    AppIcon,
    CommentBox,
    AppSeparator,
    AppActionButton,
    AppCounterRounded,
    CardModalActivityItem,
  },

  mixins: [CardActivityControl],

  data() {
    return {
      detailedActivity: false,
    }
  },

  methods: {
    toggleDetailedActivity() {
      this.detailedActivity = !this.detailedActivity
    },

    async addComment(comment) {
      const commentData = {
        cardId: this.$route.params.card_id,
        comment,
      }
      const newComment = await this.$store.dispatch('cards/addComment', commentData)

      if (!checkApiResponse) return
      return newComment
    },
  },

  computed: {
    isCardActive() {
      return this.currentCard.status === 'active'
    },

    activities() {
      return this.currentCard.activities
    },

    actionButtonText() {
      return !this.detailedActivity
        ? this.$t('card_modal.ui.activity_details_show')
        : this.$t('card_modal.ui.activity_details_hide')
    },

    selectedActivities() {
      return this.detailedActivity ? this.activities : this.featuredActivities
    },

    featuredActivities() {
      return this.activities.filter(
        (activity) => activity.type === 'comment' || this.isActivityActive(activity.id)
      )
    },

    hasOtherActivities() {
      return this.activities.filter((activity) => activity.type !== 'comment')
    },
  },
}
</script>

<style scoped>
.activity__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 40px;
}

.activity__title {
  display: flex;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  color: var(--c-primary);
}

.app-action-button {
  margin: 0;
  padding-left: 12px;
  padding-right: 12px;
}

.activity__title .app-icon {
  font-size: 20px;
  color: var(--c-secondary);
}

/* Responsive ------------- */
@media (min-width: 681px) {
  .activity__wrapper {
    padding-left: 30px;
  }
}

@media (max-width: 680px) {
  .comment-box {
    position: fixed;
    bottom: 0;
    left: 0;
    margin: 0;
    padding: 10px;
    background-color: var(--c-secondary-400);
    z-index: 50;
  }

  .comment-box >>> .app-textarea {
    padding: 10px;
  }
}
</style>
